import { observes } from "@ember-decorators/object"
import Controller from "@ember/controller"
import { action, computed, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import { task, timeout } from "ember-concurrency"
import _ from "lodash"
import hasManyCollectively from "../../helpers/has-many-collectively"

export default class SearchController extends Controller {
  @service("dispatcher")
  dispatcher

  @service("ember-store")
  store

  @service
  rpc

  queryParams = ["query", "selectedResultId"]
  query = null
  _query = null
  hasQuery = false
  isSearching = false

  @hasManyCollectively("model.planbook", "course", "courses")
  courses

  @computed("selectedResultId", "results.data.@each.id")
  get selectedResult() {
    return _.find(get(this, "results.data"), {
      id: get(this, "selectedResultId"),
    })
  }

  @observes("query")
  queryObserver() {
    if (get(this, "_query") === null) set(this, "_query", get(this, "query"))
    set(this, "hasQuery", get(this, "query") !== "" && get(this, "query") !== null)
    this.hitSearchBackend.perform(get(this, "query"))
  }

  hitSearchBackend = task({ keepLatest: true }, async (query) => {
    await timeout(150)
    set(this, "isSearching", true)
    if (query === "" || null) {
      set(this, "results", [])
      set(this, "selectedResultId", null)
      set(this, "isSearching", false)
    } else {
      await get(this, "rpc")
        .execute("PLANBOOK_SEARCH", query, get(this, "model.planbook.id"))
        .then((data) => {
          set(this, "results", data)
          set(this, "isSearching", false)
        })
        .catch((error) => {
          console.log("Error encounted in planbook search")
          console.log(error)
        })
    }
  })

  @action
  selectResult(result) {
    get(this, "dispatcher").dispatch("PLANBOOK_SEARCH_SELECT_RESULT", {
      planbookId: get(this, "model.planbook.id"),
      resultId: result.id,
    })
    set(this, "selectedResultId", result.id)
  }

  @action
  search(e) {
    let query = e.target.value
    set(this, "query", query)
  }

  @action
  leaveSearchBox(e) {
    let query = e.target.value
    if (query !== "") {
      get(this, "dispatcher").dispatch("PLANBOOK_SEARCH_BOX_UNFOCUS", {
        query: query,
        planbookId: get(this, "model.planbook.id"),
      })
    }
  }
}
